export default __webpack_public_path__ + "static/media/ordBackArrow.a1ee0eb3.svg";